export type TextDir = "ltr" | "rtl" | "auto";

const RTL_STRONG =
  /[\u0590-\u05FF\u0600-\u07BF\u0860-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFF]/g;
const LTR_STRONG = /[A-Za-z\u00C0-\u024F\u0370-\u058F\u1E00-\u1FFF]/g;

/** dir=auto picks the first strong char; weigh the whole string instead. */
export const dirForText = (text: string | null | undefined): TextDir => {
  if (!text) return "auto";
  const rtl = text.match(RTL_STRONG)?.length ?? 0;
  if (rtl === 0) return "auto";
  const ltr = text.match(LTR_STRONG)?.length ?? 0;
  return rtl >= ltr ? "rtl" : "auto";
};
